import React, { Component } from 'react';
import './Success.css';
import { Container, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'

export class Success extends Component {
    static displayName = Success.name;

    render() {
        const { t } = this.props;
        return (
            <Container className="successContainer">
                <Row className="justify-content-center">
                    <h1>Resposta enviada com sucesso!</h1>
                </Row>
                <Row className="justify-content-center sucessLines">
                    <FontAwesomeIcon icon={faCheckCircle} size="10x" className="iconColorBlue" />
                </Row>
                <Row className="justify-content-center sucessLines">
                    <span>Muito obrigado pela vossa colabora{'\u00E7'}{'\u00E3'}o.</span>    
                </Row>

                <Row className="justify-content-center sucessLines">
                    <div className="logo"></div>
                </Row>

            </Container>
        );
    }
}